__turbopack_context__.v({
  "feature-highlight": "FeatureHighlight-module-scss-module__gDKIOW__feature-highlight",
  "feature-highlight__body": "FeatureHighlight-module-scss-module__gDKIOW__feature-highlight__body",
  "feature-highlight__chip": "FeatureHighlight-module-scss-module__gDKIOW__feature-highlight__chip",
  "feature-highlight__chip-icon": "FeatureHighlight-module-scss-module__gDKIOW__feature-highlight__chip-icon",
  "feature-highlight__chips": "FeatureHighlight-module-scss-module__gDKIOW__feature-highlight__chips",
  "feature-highlight__headline": "FeatureHighlight-module-scss-module__gDKIOW__feature-highlight__headline",
});
